<template>
  <div>
    <purchase-order-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :owners="owners" @add="add" @getDetail="getDetail"/>
    <purchase-order-detail v-show="activeKey===2" ref="detail" :owners="owners" @back="back"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import PurchaseOrderList from '@/views/inbound/purchase_order_make/PurchaseOrderList.vue'
import PurchaseOrderDetail from '@/views/inbound/purchase_order_make/PurchaseOrderDetail.vue'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'PurchaseOrderMake',
  components: { PurchaseOrderList, PurchaseOrderDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      owners: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.reset()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row)
    }
  }
}
</script>